import { HoverGesture } from "../../gestures/hover";
import { FocusGesture } from "../../gestures/focus";
import { PressGesture } from "../../gestures/press";
import { InViewFeature } from "./viewport";
export const gestureAnimations = {
    inView: {
        Feature: InViewFeature,
    },
    tap: {
        Feature: PressGesture,
    },
    focus: {
        Feature: FocusGesture,
    },
    hover: {
        Feature: HoverGesture,
    },
};
//# sourceMappingURL=gestures.js.map